import { Component } from "@angular/core";

@Component({
    selector: "app-advertisement",
    templateUrl: "./promo-banner.component.html",
    styleUrl: "./promo-banner.component.scss",
    standalone: false,
})
export class PromoBannerComponent {
    advertisementData: { title: string; subtitle1: string; subtitle2: string; icon: string }[] = [
        {
            title: "On Sale 30% Off",
            subtitle1: "Grab exciting deals on top toys",
            subtitle2: "limited time only, don't miss out!",
            icon: "giftbox",
        },
        {
            title: "Buy 2 Get 1 Free",
            subtitle1: "Mix & match any sets",
            subtitle2: "Bundle Deal",
            icon: "tag",
        },
        {
            title: "Orders ₹50+",
            subtitle1: "Nationwide delivery",
            subtitle2: "Free Shipping",
            icon: "delivery",
        },
    ];
}
